export function formatDate(date: Date, minValueText: string | null = "N/A"): string {
	if (typeof (date) !== typeof (Date)) {
		date = new Date(date);
	}
	if (minValueText !== null) {
		if (date.getTime() === 0) {
			return minValueText;
		}
	}
	return date.toLocaleString("nb-NO", {year: "numeric", month: "2-digit", day:"2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false}).replace(",","");
}
export function centerOffsetForPath(pathMarkup: string) {
	const NS = "http://www.w3.org/2000/svg";
	const tmp = document.createElementNS(NS, "svg");
	tmp.setAttribute("xmlns", NS);
	tmp.setAttribute("viewBox", "0 0 250 250");
	Object.assign(tmp.style, {
		position: "absolute",
		left: "-9999px",
		top: "-9999px",
		width: "0",
		height: "0",
		overflow: "visible",
	});

	// Wrap ALL the input markup in a group so we can measure it as one shape
	const g = document.createElementNS(NS, "g");
	g.setAttribute("id", "measure");
	// Safe because we're only measuring known markup we just constructed
	g.innerHTML = pathMarkup;
	tmp.appendChild(g);
	document.body.appendChild(tmp);

	let dx = 0, dy = 0;
	try {
		// Get bbox of the GROUP (not just the first <path>)
		const b = g.getBBox(); // stroke not included; good enough for centering
		const cx = 125, cy = 125; // viewBox center
		dx = cx - (b.x + b.width / 2);
		dy = cy - (b.y + b.height / 2);
	} finally {
		tmp.remove();
	}

	return { dx, dy };
}

export function formatNumbers(value: number, numDigits: number): string {
	return new Intl.NumberFormat("no-NB", {
		maximumFractionDigits: numDigits,
		minimumFractionDigits: numDigits
	}).format(value);
}
export function toMs(t: number | string | Date): number {
	if (typeof t === 'number') {
		return t < 1e12 ? Math.round(t * 1000) : Math.round(t);
	}
	const d = t instanceof Date ? t : new Date(t);
	return d.getTime();
}